import { computed } from 'vue';

export const coreEnergyService = () => {
  // Composables
  const { t } = useI18n();

  // Store
  const { getMeterTypes } = storeToRefs(meterTypesStore());

  // Computed
  const energyTypesList = computed(() =>
    getMeterTypes.value.map((meterType) => {
      return {
        id: meterType.id,
        name: meterType.name,
        energyType: t('global.energy_type.' + meterType.energy_type),
      };
    }),
  );

  return {
    energyTypesList,
  };
};
